'use strict';

var React = require('react');
var reactUtils = require('@sravni/react-utils');
var colors = require('../../../constants/colors.js');
var variants = require('../../../constants/variants.js');
var Card_module = require('../styles/Card.module.less.js');

function _interopNamespaceDefault(e) {
    var n = Object.create(null);
    if (e) {
        Object.keys(e).forEach(function (k) {
            if (k !== 'default') {
                var d = Object.getOwnPropertyDescriptor(e, k);
                Object.defineProperty(n, k, d.get ? d : {
                    enumerable: true,
                    get: function () { return e[k]; }
                });
            }
        });
    }
    n.default = e;
    return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespaceDefault(React);

/**
 * @description Simple rectangular container
 *
 * @component
 * @example
 * ```jsx
 * <Card>content</Card>
 * ```
 */
const Card = React__namespace.forwardRef((props, ref) => {
    const { variant, size, color, shadow, className, children, ...restProps } = props;
    const cx = reactUtils.useStyles(Card_module.default);
    const classNames = cx(className, 'container', {
        [`size-${size}`]: size,
        [`color-${color}-${variant}`]: true,
        shadow,
    });
    return (React__namespace.createElement("div", { ref: ref, "data-qa": "Card", className: classNames, ...restProps }, children));
});
Card.defaultProps = {
    size: 24,
    color: colors.COLORS.LIGHT,
    variant: variants.VARIANTS.SECONDARY,
    shadow: false,
};
Card.displayName = 'Card';

exports.Card = Card;
//# sourceMappingURL=Card.js.map
